import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, requireSuperAdmin = false }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-hocp-ghost text-hocp-textSecondary text-sm">
        <span className="mono">Loading platform…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // G.4 — Force-password-change gate: block every route except the change screen itself.
  if (user.force_password_change && location.pathname !== "/force-password-change") {
    return <Navigate to="/force-password-change" replace />;
  }
  if (requireSuperAdmin && user.role !== "super_admin") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
